import React, { useState } from 'react';
import { Typography } from 'antd';

import { GenericModal } from '../../../../../shared/ui/GenericModal';
import { Confirm } from './Confirm';

const { Text } = Typography;

export const ProfileDeleteModal = ({ onCancel, onDelete, loading }) => {
    const [confirm, setConfirm] = useState(false);

    return (
        <GenericModal
            okButtonProps={{
                danger: true,
                disabled: !confirm,
                loading: loading,
            }}
            onConfirm={() => onDelete()}
            okText='Удалить'
            open={true}
            title={'Внимание!'}
            onCancel={onCancel}
        >
            <Text>
                Вы собираетесь <Text type={'danger'}>удалить </Text>
                свою учётную запись. Это происходит моментально и данные будут
                удалены безвозвратно.
            </Text>

            <Confirm confirm={confirm} setConfirm={setConfirm} />
        </GenericModal>
    );
};
